import { render, staticRenderFns } from "./addTaskStoryModal.vue?vue&type=template&id=a38ea69c&scoped=true"
import script from "./addTaskStoryModal.vue?vue&type=script&lang=js"
export * from "./addTaskStoryModal.vue?vue&type=script&lang=js"
import style0 from "./addTaskStoryModal.vue?vue&type=style&index=0&id=a38ea69c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38ea69c",
  null
  
)

export default component.exports